<script setup lang="ts">
const props = defineProps<{
    noPadding?: boolean;
}>();
</script>

<template>
    <div
        class="grid grid-cols-1 md:grid-cols-2 gap-8 w-full items-start"
        :class="{ 'px-8 py-4': props.noPadding !== true }"
    >
        <slot></slot>
    </div>
</template>
